module.exports = __webpack_public_path__ + "img/tel.db3a81c5.png";